import { render, staticRenderFns } from "./MyProfilesPage.vue?vue&type=template&id=69048e34&scoped=true&"
import script from "./MyProfilesPage.vue?vue&type=script&lang=js&"
export * from "./MyProfilesPage.vue?vue&type=script&lang=js&"
import style0 from "./MyProfilesPage.vue?vue&type=style&index=0&id=69048e34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69048e34",
  null
  
)

export default component.exports